import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import * as moment from 'moment';
import { Subscription } from 'rxjs/internal/Subscription';
import { AppMainService } from 'src/app/app-main.service';
import { AppMainComponent } from 'src/app/app.main.component';
import { DataService } from '../../dataService';
import { IReportsFilterModel } from '../../models/reports-filter.models';
import { ReportsCaseRoutes, typeReportsCaseRoutes } from '../../models/reports.models';
import { ReportService } from '../../reportService';

@Component({
    selector: 'app-case-reports',
    templateUrl: './case-reports.component.html',
    styleUrls: ['./case-reports.component.scss']
})
export class CaseReportsComponent implements OnInit, OnDestroy {

    //#region Properties
    public selectedWindow: string = '';
    public reportName: string = '';
    public dateFrom: any;
    public dateTo: any;
    public reportDate: Date = new Date();
    public pageSize: number = 0;
    public pageNumber: number = 15;

    public cols: any;
    public reportsData = [];
    public totalRecords: number;
    public totalPages: number;
    public results = [];
    public IsShowReportTemplate: boolean = true;
    public noContactFindOrLoadingText = 'Loading....';
    subscription: Subscription = new Subscription();
    //#endregion

    // CTOR
    constructor(public app: AppMainComponent,
        private appMainService: AppMainService,
        private reportService: ReportService,
        private router: ActivatedRoute,
        private dataService: DataService
    ) {
        this.subscription = this.dataService.getData().subscribe(data => {
            this.onGlobalSearch(data);
        });
    }

    ngOnInit(): void {
        this.subscription = this.router.paramMap.subscribe((param: any) => {
            const activityType: typeReportsCaseRoutes = param.params.type;
            switch (activityType) {
                case ReportsCaseRoutes.casesByCategorySummary:
                    this.selectedWindow = "casesByCategorySummary";
                    break;
                case ReportsCaseRoutes.casesByCategoryDetails:
                    this.selectedWindow = "casesByCategoryDetails";
                    break;
                case ReportsCaseRoutes.casesByRepSummary:
                    this.selectedWindow = "casesByRepSummary";
                    break;
                case ReportsCaseRoutes.casesByRepDetails:
                    this.selectedWindow = "casesByRepDetails";
                    break;
                case ReportsCaseRoutes.casesBySourceSummary:
                    this.selectedWindow = "casesBySourceSummary";
                    break;
                case ReportsCaseRoutes.casesBySourceDetails:
                    this.selectedWindow = "casesBySourceDetails";
                    break;
                case ReportsCaseRoutes.casesByAccounts:
                    this.selectedWindow = "casesByAccounts";
                    break;
                case ReportsCaseRoutes.casesByLeads:
                    this.selectedWindow = "casesByLeads";
                    break;
                default:
                    break;
            }
            this.casesReport(0, this.app.companyId, this.app.userId, this.pageSize, this.pageNumber, this.selectedWindow, null, this.app.companyId);
        });
    }

    ngOnDestroy(): void {
        this.subscription?.unsubscribe();
    }

    public casesReport(selectedChannelId: number, companyId: number, userId, currentPageSize: number = 15, currentPageNumber: number = 1, selectedWindow: string, selectedUser: object, selectedOrganizationId: number, searchValue?: any) {

        this.appMainService.isShowSpinner('CasesReport');
        switch (this.selectedWindow) {
            case 'casesByCategorySummary': {
                this.cols = [
                    { field: 'categoryName', header: 'Category' },
                    { field: 'subCategory', header: 'Sub-Category' },
                    { field: 'channel', header: 'Channel' },
                    { field: 'status', header: 'Status' },
                    { field: 'totalCases', header: 'Total Cases' },
                ];
                this.reportName = 'Cases By Category Summary';
                break;
            }

            case 'casesByCategoryDetails': {
                this.cols = [
                    { field: 'categoryName', header: 'Category' },
                    { field: 'subCategory', header: 'Sub-Category' },
                    { field: 'channel', header: 'Channel' },
                    { field: 'status', header: 'Status' },
                    { field: 'stage', header: 'Stage' },
                    { field: 'ticketId', header: 'Ticket No.' },
                    { field: 'createBy', header: 'Created By' },
                    { field: 'createDate', header: 'Created Date' },
                ];
                this.reportName = 'Cases By Category Details';
                break;
            }
            case 'casesByRepSummary': {
                this.cols = [
                    { field: 'assignedUser', header: 'Assigned User' },
                    { field: 'channel', header: 'Channel' },
                    { field: 'status', header: 'Status' },
                    { field: 'totalCases', header: 'Total Cases' },
                ];
                this.reportName = 'Cases By Rep Summary';
                break;
            }
            case 'casesByRepDetails': {
                this.cols = [
                    { field: 'assignedUser', header: 'Assigned User' },
                    { field: 'channel', header: 'Channel' },
                    { field: 'status', header: 'Status' },
                    { field: 'stage', header: 'Stage' },
                    { field: 'ticketId', header: 'Ticket No.' },
                    { field: 'createBy', header: 'Created By' },
                    { field: 'createDate', header: 'Created Date' },
                ];
                this.reportName = 'Cases By Rep Details';
                break;
            }

            case 'casesBySourceSummary': {
                this.cols = [
                    { field: 'sourceName', header: 'Source' },
                    { field: 'channel', header: 'Channel' },
                    { field: 'status', header: 'Status' },
                    { field: 'totalCases', header: 'Total Cases' },
                ];
                this.reportName = 'Cases By Source Summary';
                break;
            }

            case 'casesBySourceDetails': {
                this.cols = [
                    { field: 'sourceBox', header: 'Source' },
                    { field: 'channel', header: 'Channel' },
                    { field: 'status', header: 'Status' },
                    { field: 'stage', header: 'Stage' },
                    { field: 'ticketNo', header: 'Ticket No.' },
                    { field: 'createBy', header: 'Created By' },
                    { field: 'createDate', header: 'Created Date' },
                ];
                this.reportName = 'Cases By Source Details';
                break;
            }
            case 'casesByAccounts': {
                this.cols = [
                    { field: 'channel', header: 'Channel' },
                    { field: 'accountName', header: 'Account Name' },
                    { field: 'assignedUser', header: 'Assigned User' },
                    { field: 'ticketNo', header: 'Ticket No.' },
                    { field: 'categoryName', header: 'Category' },
                    { field: 'subCategory', header: 'Sub-Category' },
                    { field: 'status', header: 'Status' },
                    { field: 'stage', header: 'Stage' },
                    { field: 'createBy', header: 'Created By' },
                    { field: 'createDate', header: 'Created Date' },
                    { field: 'updateDate', header: 'Updated Date' },
                ];

                this.reportName = 'Cases By Accounts';
                break;
            }
            case 'casesByLeads': {
                this.cols = [
                    { field: 'channel', header: 'Channel' },
                    { field: 'leadName', header: 'Lead Name' },
                    { field: 'assignedUser', header: 'Assigned User' },
                    { field: 'ticketNo', header: 'Ticket No.' },
                    { field: 'categoryName', header: 'Category' },
                    { field: 'subCategory', header: 'Sub-Category' },
                    { field: 'status', header: 'Status' },
                    { field: 'stage', header: 'Stage' },
                    { field: 'createBy', header: 'Created By' },
                    { field: 'createDate', header: 'Created Date' },
                    { field: 'updateDate', header: 'Updated Date' },
                ];

                this.reportName = 'Cases By Leads';
                break;
            }
            default: {
                break;
            }
        }
        // this.OrganizationName = this.app.user.organizationName;


        this.reportService.AllCasesReport(selectedChannelId, currentPageSize, currentPageNumber,
            this.formatDate(this.dateFrom),
            this.formatDate(this.dateTo), this.selectedWindow,
            selectedUser, null, null, null,
            null, null, null,
            null, null, searchValue).then(res => {
                this.reportsData = [];
                this.totalRecords = 0;
                this.results = [];
                this.totalPages = 0;
                let { contacts, headers } = res;
                this.IsShowReportTemplate = true;
                this.appMainService.isHideSpinner('CasesReport');
                this.reportsData = JSON.parse(JSON.stringify(contacts));

                this.totalRecords = headers['TotalCount'];
                //added for PDF
                this.results = JSON.parse(JSON.stringify(contacts));
                this.totalPages = headers['TotalPages']
                //added for PDF

            }).finally(() => {
                this.appMainService.isHideSpinner('CasesReport');
                this.noContactFindOrLoadingText = 'No Reports Available.';
            });
    }

    private formatDate(date: Date) {
        return moment(date).format('MM-DD-YYYY');
    }

    onRemoveFilter(selectedWindow: string, selectedFilters: IReportsFilterModel[]): void {
        // console.log("onRemoveFilter", event);
        this.casesReport(0, this.app.companyId, this.app.userId, this.pageSize, this.pageNumber, this.selectedWindow, null, this.app.companyId);
    }

    onClosePanel(selectedWindow: string): void {
        //this.DownloadReport(selectedWindow);
    }

    onApplyFilter(selectedWindow: string, selectedFilters: IReportsFilterModel[]): void {
        this.casesReport(0, this.app.companyId, this.app.userId, this.pageSize, this.pageNumber, this.selectedWindow, null, this.app.companyId);
    }

    onChangeRange(selectedWindow: string, event: any): void {
        //this.selectedDateFilter = event;
        this.casesReport(0, this.app.companyId, this.app.userId, this.pageSize, this.pageNumber, this.selectedWindow, null, this.app.companyId);
    }

    onGlobalSearch(searchValue: any) {
        this.casesReport(0, this.app.companyId, this.app.userId, this.pageSize, this.pageNumber, this.selectedWindow, null, this.app.companyId, searchValue);
    }
}
